<form [formGroup]="formGroupStatus">
  <snelstart-ui-text-form-control [disabledControl]="true"
                                  class="custom-input-275"
                                  formControlName="status"
                                  id="machtigingStatus"
                                  label="Huidige status"
  >
  </snelstart-ui-text-form-control>
</form>
<form [formGroup]="formGroup">
  @if (this.mumaEntity.machtigingStatusToelichting !== null &&
  (!this.mumaEntity.machtigingStatus?.includes('CONTROLEREN') && !this.mumaEntity.machtigingStatus?.includes('ONTVANGEN') &&
    !this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING')) ||
  (this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING') && this.mumaEntity.type?.includes('SBA_TSG')) ||
  (this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING') && this.mumaEntity.type?.includes('VIA')) ||
  (this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING') && this.mumaEntity.type?.includes('DoMa'))) {
    <snelstart-ui-textarea-form-control [disabledControl]="true"
                                        [rows]="10"
                                        class="me-1 custom-input-275"
                                        formControlName="machtigingStatusToelichting"
                                        id="machtigingStatusToelichting"
                                        label="Toelichting Belastingdienst op status"
    >
    </snelstart-ui-textarea-form-control>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING') && this.checkIsOptInMachtiging(this.mumaEntity.mumaRequest?.dienst)) {
    <div formGroupName="mumaRequest">
      <snelstart-ui-text-form-control (change)="this.saveForm()"
                                      class="me-1 custom-input-275"
                                      formControlName="activatieToken"
                                      id="Activeringscode"
                                      label="Activeringscode">
      </snelstart-ui-text-form-control>
    </div>
    <snelstart-ui-alert type="info">
      Let op, na het activeren van de machtiging kan het 24 uur duren voordat de Belastingdienst de status van de machtiging wijzigt.
      In je overzicht zal de machtiging mogelijk nog 24 uur 'Activeren' blijven staan.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('UNKNOWN')) {
    <snelstart-ui-alert type="info">
      De status van de (mutatie in de) machtigingsaanvraag is momenteel onbekend.
      Blijft de status een aantal dagen 'Onbekend', probeer dan de machtiging opnieuw op te voeren of neem
      contact op met onze klantenservice.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('ONTVANGEN')) {
    <snelstart-ui-alert type="info">
      Het aanvragen van de machtiging is door de Belastingdienst ontvangen. Er is op dit moment geen actie
      nodig. Zodra er een wijziging in de status wordt ontvangen, vind je hier de nieuwe status.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('AFGEKEURD')) {
    <snelstart-ui-alert type="info">
      Het aanvragen van de machtiging bij de Belastingdienst is niet gelukt.
      In veel gevallen is dan de opt-in termijn verlopen. Probeer de machtiging nogmaals op te voeren, door
      rechtsboven op 'Aanvragen' te klikken.
      Wordt de machtiging weer afgekeurd, neem dan contact onze klantenservice op.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('CONTROLEREN')) {
    <snelstart-ui-alert type="info">
      De status van de machtiging wordt opgevraagd bij de Belastingdienst.
      Er is op dit moment geen actie nodig. Zodra de status wordt ontvangen, vind je die hier.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING') && !this.checkIsOptInMachtiging(this.mumaEntity.mumaRequest?.dienst)) {
    <snelstart-ui-alert type="info">
      Het aanvragen van de opt-out machtiging is verwerkt.
      De klant (belastingplichtige) heeft 6 weken om aan geven dat de machtiging niet gewenst is. Na de bezwaartermijn
      is de machtiging actief.
      Er is op dit moment geen actie nodig.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('NIET_ACTIEF') && this.mumaEntity.machtigingStatusToelichting?.includes('Er is reeds een machtiging voor een andere gemachtigde')) {
    <snelstart-ui-alert type="info">
      De machtiging is momenteel niet actief omdat er een actieve machtiging is bij een ander kantoor.
      Je kunt pas een machtiging voor deze klant aanvragen als de machtiging voor het andere kantoor is ingetrokken.
    </snelstart-ui-alert>
  }

  @if (this.mumaEntity.machtigingStatus?.includes('IN_BEHANDELING') && this.checkIsOptInMachtiging(this.mumaEntity.mumaRequest?.dienst)) {
    <snelstart-ui-alert type="info">
      De machtigingscode voor de opt-in machtiging is ontvangen door de klant.
      Vraag de machtigingscode op bij de klant en voer deze in (inclusief eventuele streepjes!). Klik daarna
      rechtsboven op' Activeren'.
    </snelstart-ui-alert>
  }
</form>
